/** Nij Begun postcode areas (PC4) — Groningen region. */
export const NIJ_BEGUN_PC4 = [
  '9301', '9302', '9304', '9305', '9307', '9311', '9312', '9313', '9314', '9315', '9321', '9331', '9333', '9334', '9335', '9336', '9337', '9341', '9342', '9343', '9347',
  '9401', '9402', '9403', '9404', '9405', '9406', '9407', '9408', '9409', '9411', '9412', '9413', '9414', '9415', '9417', '9418', '9421', '9422', '9423', '9431', '9432', '9433', '9434', '9435', '9436', '9437', '9438', '9439', '9441', '9442', '9443', '9444', '9445', '9446', '9447', '9448', '9449', '9451', '9452', '9453', '9454', '9455', '9456', '9457', '9458', '9459', '9461', '9462', '9463', '9464', '9465', '9466', '9467', '9468', '9469', '9471', '9472', '9473', '9474', '9475', '9479', '9481', '9482', '9483', '9484', '9485', '9486', '9487', '9488', '9489', '9491', '9492', '9493', '9494', '9495', '9496', '9497',
  '9501', '9502', '9511', '9512', '9514', '9515', '9521', '9523', '9524', '9525', '9527', '9528', '9531', '9533', '9534', '9535', '9541', '9545', '9551', '9561', '9563', '9564', '9566', '9571', '9573', '9574', '9581', '9584', '9585',
  '9601', '9602', '9603', '9605', '9606', '9607', '9608', '9609', '9611', '9613', '9614', '9615', '9616', '9617', '9618', '9619', '9621', '9622', '9623', '9624', '9625', '9626', '9627', '9628', '9629', '9631', '9632', '9633', '9635', '9636', '9641', '9642', '9644', '9645', '9646', '9648', '9649', '9651', '9654', '9655', '9656', '9657', '9658', '9659', '9661', '9663', '9665', '9671', '9672', '9673', '9674', '9675', '9677', '9678', '9679', '9681', '9682', '9684', '9685', '9686', '9687', '9688', '9691', '9693', '9695', '9696', '9697', '9698', '9699',
  '9711', '9712', '9713', '9714', '9715', '9716', '9717', '9718', '9721', '9722', '9723', '9724', '9725', '9726', '9727', '9728', '9731', '9732', '9733', '9734', '9735', '9736', '9737', '9738', '9741', '9742', '9743', '9744', '9745', '9746', '9747', '9749', '9751', '9752', '9753', '9755', '9756', '9761', '9765', '9766', '9771', '9773', '9774', '9781', '9784', '9785', '9791', '9792', '9793', '9794', '9795', '9796', '9797', '9798',
  '9811', '9812', '9821', '9822', '9824', '9825', '9827', '9828', '9831', '9832', '9833', '9841', '9842', '9843', '9844', '9845', '9861', '9862', '9863', '9864', '9865', '9866', '9881', '9882', '9883', '9884', '9885', '9886', '9891', '9892', '9893',
  '9901', '9902', '9903', '9904', '9905', '9906', '9907', '9908', '9909', '9911', '9912', '9913', '9914', '9915', '9917', '9918', '9919', '9921', '9922', '9923', '9924', '9925', '9931', '9932', '9933', '9934', '9936', '9937', '9939', '9942', '9943', '9944', '9945', '9946', '9947', '9948', '9949', '9951', '9953', '9954', '9955', '9956', '9957', '9959', '9961', '9962', '9963', '9964', '9965', '9966', '9967', '9968', '9969', '9971', '9972', '9973', '9974', '9975', '9976', '9977', '9978', '9979', '9981', '9982', '9983', '9984', '9985', '9986', '9987', '9988', '9989', '9991', '9992', '9993', '9994', '9995', '9996', '9997', '9998', '9999',
];

/** Local reinforcement list — extend via server JSON for production. */
const VERSTERKINGS_SET = new Set([
  '9996VC|17-A',
  '9996VC|1',
  '9996VC|11',
  '9996VC|13',
  '9996VC|15',
  '9996VC|25',
  '9995NC|23',
  '9995NC|23-M-1',
  '9995NC|32-A-01',
  '9943PA|55-B',
  '9943PA|55-A',
  '9943PA|15',
  '9943PA|17',
]);

export const normalizePostcode = (value) => String(value || '').replace(/\s/g, '').toUpperCase();

export const normalizeHuisnummer = (value) =>
  String(value || '')
    .trim()
    .toUpperCase()
    .replace(/\s+/g, '-')
    .replace(/--+/g, '-');

export const makeAddressKey = (postcode, huisnummer) =>
  `${normalizePostcode(postcode)}|${normalizeHuisnummer(huisnummer)}`;

export const isValidDutchPostcode = (postcode) => /^[1-9][0-9]{3}[A-Z]{2}$/.test(normalizePostcode(postcode));

export async function fetchBagAddress(postcode, huisnummer) {
  const query = encodeURIComponent(`${normalizePostcode(postcode)} ${normalizeHuisnummer(huisnummer)}`);
  const fields = [
    'weergavenaam', 'straatnaam', 'huisnummer', 'huisletter',
    'huisnummertoevoeging', 'postcode', 'woonplaatsnaam',
    'gemeentenaam', 'provincienaam', 'adresseerbaarobject_id', 'id',
  ].join(',');

  const url =
    `https://api.pdok.nl/bzk/locatieserver/search/v3_1/free?q=${query}` +
    `&fq=type:adres&rows=1&fl=${fields}`;

  const response = await fetch(url);
  if (!response.ok) throw new Error('PDOK/BAG could not be reached.');

  const data = await response.json();
  const docs = data?.response?.docs ?? [];
  return docs.length ? docs[0] : null;
}

/**
 * @returns {Promise<{
 *   status: 'invalid_postcode'|'missing_huisnummer'|'outside_region'|'full'|'partial',
 *   postcode: string,
 *   huisnummer: string,
 *   bagAddress?: object|null,
 *   bagError?: string|null,
 * }>}
 */
export async function checkNijBegunSubsidie(postcodeRaw, huisnummerRaw) {
  const postcode = normalizePostcode(postcodeRaw);
  const huisnummer = normalizeHuisnummer(huisnummerRaw);

  if (!isValidDutchPostcode(postcode)) {
    return { status: 'invalid_postcode', postcode, huisnummer };
  }

  if (!huisnummer) {
    return { status: 'missing_huisnummer', postcode, huisnummer };
  }

  let bagAddress = null;
  let bagError = null;
  try {
    bagAddress = await fetchBagAddress(postcode, huisnummer);
  } catch (error) {
    bagError = error?.message || 'BAG lookup failed';
  }

  const pc4 = postcode.substring(0, 4);
  const inNijBegunGebied = NIJ_BEGUN_PC4.includes(pc4);
  const inVersterking = VERSTERKINGS_SET.has(makeAddressKey(postcode, huisnummer));

  if (!inNijBegunGebied) {
    return { status: 'outside_region', postcode, huisnummer, bagAddress, bagError };
  }

  if (inVersterking) {
    return { status: 'full', postcode, huisnummer, bagAddress, bagError };
  }

  return { status: 'partial', postcode, huisnummer, bagAddress, bagError };
}
